import { lazy } from 'react';
import { useRoutes } from 'react-router-dom';
import NotFoundPage from '../pages/NotFoundPage';
import RedirectSDKPage from '../pages/RedirectSdk';
import { GuardPayment, GuardRedirectRoute } from './Guard/GuardRedirectRoute';

const MainPage = lazy(() => import('../pages/MainPage'));
const MainContent = lazy(() => import('../components/shared/MainContent'));
const OutcamePage = lazy(() => import('../pages/OutcamePage'));
const VerifyPostePayPage = lazy(() => import('../pages/VerifyPostePayPage'));
const SatispayPage = lazy(() => import('../pages/SatispayPage'));
const PaypalPage = lazy(() => import('../pages/PayPalPage'));
const PosteForm = lazy(() => import('../components/form/PosteForm'));

export default function Routers() {
    return useRoutes([
        {
            path: '/:id/:key',
            element: (
                <MainPage />
            ),
            children: [
                {
                    path: '/:id/:key',
                    element: 
                    <GuardPayment>
                        <MainContent />
                    </GuardPayment>
                },
                {
                    path: '/:id/:key/redirect',
                    element: 
                    <GuardRedirectRoute>
                        <PosteForm />
                    </GuardRedirectRoute> 
                },
                {
                    path: "/:id/:key/redirectSDK",
                    element: <GuardRedirectRoute>
                        <RedirectSDKPage />
                    </GuardRedirectRoute>
                },
                // { path: '/:id/:key/outcome', element: <OutcomeGuard><OutcamePage /></OutcomeGuard>  },
                { path: '/:id/:key/outcome', element: <OutcamePage /> },
                { path: '/:id/:key/verifyPostePay', element: <VerifyPostePayPage /> },
                { path: '/:id/:key/satispay', element: <SatispayPage /> },
                { path: '/:id/:key/paypal', element: <PaypalPage /> },
                { path: '*', element: <div>OPS: NOT FOUND PAGE !</div> },
            ],
        },
        { path: '*', element: <NotFoundPage /> }
    ])
}